import { FT } from 'ft'
import { Sprite } from 'pixi.js'
import Mask from '#/components/Mask'

const $spinnerIn = 'spinner-in'
const $spinnerOut = 'spinner-out'

const { rm } = FT

rm.addImage($spinnerIn)
rm.addImage($spinnerOut)

class Spinner extends Mask {
  constructor() {
    super()
    this.pivot.set(this.width / 2, this.height / 2)

    const spinnerIn = new Sprite(rm.texture($spinnerIn))
    spinnerIn.anchor.set(0.5)
    spinnerIn.scale.set(1.2)
    spinnerIn.position.set(this.width / 2, this.height / 2)
    const spinnerOut = new Sprite(rm.texture($spinnerOut))
    spinnerOut.anchor.set(0.5)
    spinnerOut.scale.set(1.2)
    spinnerOut.position.set(this.width / 2, this.height / 2)

    this.addChild(spinnerIn)
    this.addChild(spinnerOut)

    const spin = dt => {
      const speed = 0.1 * dt
      spinnerOut.rotation += speed
      spinnerIn.rotation -= speed
    }

    this.on('added', () => {
      FT.ticker.add(spin)
    })

    this.on('removed', () => {
      FT.ticker.remove(spin)
    })
  }
}

export default Spinner
